// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ContentEditable__Wrapper_316T0"};